import { ISlotDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { ISlotLabelDecorator } from './i.slot-label-decorator';

export class SlotHouseAreaLabelDecorator implements ISlotLabelDecorator {
    public writeLabel = (item: ISlotDto, label: string): string => {
        return `${item.houseArea.label} - ${label}`;
    };
}
